import { ButtonTheme } from './types';
import colors from '../colors';

const button: ButtonTheme = {
    primary: {
        textColor: colors.white,
        bgColor: colors.blue
    },
    success: {
        textColor: colors.white,
        bgColor: colors.limeGreen
    },
    success_2: {
        textColor: colors.pureWhite,
        bgColor: colors.darkGreen
    },
    success_3: {
        textColor: colors.pureWhite,
        bgColor: colors.blue
    }
};

export default button;
